<!-- Digital Twin City Infrastructure Platform Introduction -->
<template>
  <div class="dtwin-city-intro">
    <div class="dtwin-city-intro-wrapper">
      <header
        class="dtwin-city-intro-hd"
        v-scroll-animate="{
          animation: 'fadeInUp',
        }"
      >
        <!-- Digital Twin City Infrastructure Platform Introduction -->
        {{ tittle }}
      </header>
      <article class="dtwin-city-intro-bd">
        <p
          v-scroll-animate="{
            animation: 'fadeInUp',
            delay: 100,
            duration: 800,
          }"
        >
          The Digital Twin City Infrastructure Platform integrates physical
          entities, data, and models of the city to enable real-time simulation,
          monitoring, and management of urban environments. Key capabilities
          include:
        </p>
        <p
          class="intro-item"
          v-scroll-animate="{
            animation: 'fadeInUp',
            delay: 200,
            duration: 600,
          }"
        >
          ·Data Integration and Management
        </p>
        <p
          class="intro-item"
          v-scroll-animate="{
            animation: 'fadeInUp',
            delay: 200,
            duration: 600,
          }"
        >
          ·Simulation and Modeling
        </p>
        <p
          class="intro-item"
          v-scroll-animate="{
            animation: 'fadeInUp',
            delay: 200,
            duration: 600,
          }"
        >
          ·Visualization and Interaction
        </p>
        <p
          class="intro-item"
          v-scroll-animate="{
            animation: 'fadeInUp',
            delay: 200,
            duration: 600,
          }"
        >
          ·Data Analysis and Decision Support
        </p>
        <p
          class="intro-item"
          v-scroll-animate="{
            animation: 'fadeInUp',
            delay: 200,
            duration: 600,
          }"
        >
          ·Real-Time Monitoring and Early Warning
        </p>
        <p
          class="intro-item"
          v-scroll-animate="{
            animation: 'fadeInUp',
            delay: 200,
            duration: 600,
          }"
        >
          ·Sustainable Development and Optimization
        </p>
        <p
          class="intro-extra"
          v-scroll-animate="{
            animation: 'fadeInUp',
            delay: 300,
            duration: 600,
          }"
        >
          This platform provides comprehensive urban information and decision
          support to city decision-makers, planners, and citizens, helping to
          achieve smarter, more efficient, and sustainable urban development.
        </p>
      </article>
      <footer
        class="dtwin-city-intro-ft"
        v-scroll-animate="{
          animation: 'fadeInUp',
          delay: 400,
          duration: 600,
        }"
      >
        <aside class="intro-ft-aside">
          <img
            src="@/assets/images/dtwin/twin-city-1.png"
            class="aside-img"
            alt=""
          />
        </aside>
        <article class="intro-ft-main">
          <img
            src="@/assets/images/dtwin/twin-city-2.png"
            class="main-img"
            alt=""
          />
          <img
            src="@/assets/images/dtwin/twin-city-3.png"
            class="main-img"
            alt=""
          />
        </article>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  name: "Solution",
  components: {},
  data() {
    return {
      tittle: "Digital Twin City Infrastructure Platform",
    };
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style scoped lang="scss">
.dtwin-city-intro {
  padding: 80px 0;
  background: #fff;
  .dtwin-city-intro-wrapper {
    width: 1200px;
    margin: 0 auto;
  }

  .dtwin-city-intro-hd {
    margin-bottom: 40px;
    font-weight: bold;
    font-size: 32px;
    color: #333;
    line-height: 24px;
    text-align: center;
    font-style: normal;
  }
  .dtwin-city-intro-bd {
    margin-bottom: 40px;
    font-weight: 400;
    font-size: 18px;
    color: #1d1d1f;
    line-height: 32px;
    text-align: justify;
    font-style: normal;
    .intro-item {
      padding-left: 20px;
    }
    .intro-extra {
    }
  }
  .dtwin-city-intro-ft {
    display: flex;
    height: 440px;
    .intro-ft-aside {
      width: 782px;
      margin-right: 12px;
    }
    .intro-ft-main {
      flex: 1;
    }
    .aside-img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .main-img {
      width: 404px;
      height: 212px;
      object-fit: cover;
      box-sizing: border-box;

      &:first-child {
        margin-bottom: 16px;
      }
    }
  }
}
</style>
